export default function SeoFooter() {
  return (
    <footer className="relative z-10 bg-[#0d0a1e] py-14 text-snk-ink">
      <div className="mx-auto w-full max-w-6xl px-6">
        <section aria-labelledby="snk-seo-about" className="mb-12">
          <h2 id="snk-seo-about" className="font-display text-xl font-bold">
            Play Snakes and Ladders Online — A Free Classic Board Game
          </h2>
          <p>
            Snakes and Ladders is a free, real-time multiplayer version of the beloved race to
            100, playable in your browser with friends — no downloads, no accounts, just a
            6-letter room code. Roll the dice, climb ladders, slide down snakes, and land
            exactly on square 100 to win. Up to 4 players per room.
          </p>
        </section>

        <section aria-labelledby="snk-seo-howto" className="mb-12">
          <h2 id="snk-seo-howto">How to Play Snakes and Ladders</h2>
          <ol>
            <li>Open etoo.in/snake-ladder and type a nickname.</li>
            <li>Create a game room to get a 6-letter room code, and share it with your friends.</li>
            <li>On your turn, roll the dice. Your token hops that many squares.</li>
            <li>Land on a ladder to climb up, or a snake to slide down.</li>
            <li>You must land exactly on 100 to win. A 6 grants an extra roll.</li>
          </ol>
        </section>

        <section aria-labelledby="snk-seo-faq">
          <h2 id="snk-seo-faq">Frequently Asked Questions</h2>
          <div className="space-y-6">
            <article>
              <h3>Is Snakes and Ladders free to play?</h3>
              <p>Yes. Completely free — no downloads, sign-ups, or accounts. Play with up to 4 friends.</p>
            </article>
            <article>
              <h3>How many players can join?</h3>
              <p>Each room supports 2 to 4 players. You need at least 2 to start.</p>
            </article>
            <article>
              <h3>Can I play on my phone?</h3>
              <p>Yes. It works in any modern browser on phones, tablets, and desktops.</p>
            </article>
          </div>
        </section>

        <nav className="mt-14 border-t border-snk-border/70 pt-8" aria-label="More games">
          <p className="text-sm font-bold text-snk-ink/70">More games at etoo</p>
          <ul className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <li>
              <a className="text-snk-accent hover:underline" href="/ludo/">
                Ludo online
              </a>
            </li>
            <li>
              <a className="text-snk-accent hover:underline" href="/pictionary/">
                Pictionary online
              </a>
            </li>
            <li>
              <a className="text-snk-accent hover:underline" href="/splendour/">
                Splendour online
              </a>
            </li>
            <li>
              <a className="text-snk-accent hover:underline" href="/ticket-to-train/">
                Ticket to Train online
              </a>
            </li>
          </ul>
        </nav>

        <p className="mt-10 text-center text-xs text-snk-ink/40">
          © {new Date().getFullYear()} etoo games · Snakes and Ladders — free online classic for 2–4 players
        </p>
      </div>
    </footer>
  );
}
